import React from 'react';
import Btn from '../Btn';
import { BtnModifier } from '../Btn';
import { SVGIcon } from '../../../atoms/SVG';
import { TooltipPlacement } from '../../../atoms/Tooltip';
import { SharedButtonProps } from './SharedButtonProps';

export type MicroInteractionState = 'idle' | 'busy' | 'failed' | 'activated';
export type MicroInteractionColor = 'blue' | 'dark' | 'red' | 'petrol';

type ButtonMicroInteractionSpecificProps = {
  text: string;
  icon: SVGIcon;
  state?: MicroInteractionState;
  color?: MicroInteractionColor;
  tooltipPlacement?: TooltipPlacement;
};

export type ButtonMicroInteractionProps = SharedButtonProps & ButtonMicroInteractionSpecificProps;

const colorModifiers: Record<MicroInteractionColor, BtnModifier> = {
  blue: BtnModifier.MINOR_ACTION_ACTIVATED_BLUE,
  dark: BtnModifier.MINOR_ACTION_ACTIVATED_DARK,
  red: BtnModifier.MINOR_ACTION_ACTIVATED_RED,
  petrol: BtnModifier.MINOR_ACTION_ACTIVATED_PETROL,
};

export function ButtonMicroInteraction({
  text,
  icon,
  onClick,
  disabled,
  ariaDisabled,
  state = 'idle',
  color = 'petrol',
  ariaLabel,
  tooltipPlacement,
  ...rest
}: ButtonMicroInteractionProps) {
  const baseModifiers = [BtnModifier.MICRO_INTERACTION, BtnModifier.TRANSPARENT, BtnModifier.MINOR_ACTION];

  let modifier: BtnModifier[];

  if (state === 'busy') {
    modifier = [...baseModifiers, BtnModifier.MINOR_ACTION_BUSY];
  } else if (state === 'failed') {
    modifier = [...baseModifiers, BtnModifier.MINOR_ACTION_FAILED];
  } else if (state === 'activated') {
    modifier = [...baseModifiers, BtnModifier.MINOR_ACTION_ACTIVATED, colorModifiers[color]];
  } else {
    modifier = baseModifiers;
  }

  return (
    <Btn
      {...rest}
      modifier={modifier}
      text={text}
      svgSpriteId={icon}
      hiddenText
      onClick={onClick}
      disabled={disabled}
      ariaDisabled={ariaDisabled}
      type="button"
      titleText={text}
      ariaLabel={ariaLabel}
      tooltipPlacement={tooltipPlacement}
    />
  );
}
